import { Layout, Spin, Image } from 'antd';
import logo from '../assets/logo_transparent.png';

function FullScreenLoading() {
    return (
        <Layout
            style={{
                backgroundColor: '#1c3450',
                height: '100dvh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 50,
                flexDirection: 'column',
            }}
        >
            <Image preview={false} src={logo} alt="BindFind" />
            <Spin className="white-spin" size="large" />
        </Layout>
    );
}

export default FullScreenLoading;
